if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        // this.cartNotification = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.sideCart = document.querySelector("side-cart");
        this.cartSettings = JSON.parse(document.querySelector("#cart-drawer-settings").textContent);

        // create a new instance of the Upsell class for the product form's upsell popup
        this.popupUpsell = new PopupUpsell(this.cartSettings.recommended__first_product);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const _this = this; 
        const upsell_popup = document.querySelector("#upsell-popup");
        const showed_popup_for =
          JSON.parse(sessionStorage.getItem("showed_popup_for")) || [];

        if (!showed_popup_for.includes(window.location.pathname) && upsell_popup ) {
          this.popupUpsell.toggle_upsell_popup();

          sessionStorage.setItem(
            "showed_popup_for",
            JSON.stringify([...showed_popup_for, window.location.pathname])
          );

          return;
        }

        this.handleErrorMessage();
        // this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              // document.body.addEventListener('modalClosed', () => {
              //   setTimeout(() => { this.cartNotification.renderContents(response) });
              // }, { once: true });
              quickAddModal.hide(true);
            } else {
              if (_this.cartSettings.use_rebuy_cart) {
                window.Rebuy.SmartCart.show();
              } else {
                await _this.sideCart.renderCart(true);
                _this.sideCart.open();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (
  document.querySelector(".size-guide-btn") &&
  document.querySelector("#size-guide-popup-wrapper")
) {
  const sizeGuideBtn = document.querySelector(".size-guide-btn");
  const sizeGuidePopup = document.querySelector("#size-guide-popup-wrapper");
  const sizeGuideZoomWrapper = sizeGuidePopup.querySelector(".size-img");
  const sizeGuidePopupClose = document.querySelector(
    "#size-guide-popup-wrapper .close-popup"
  );
  sizeGuideBtn.addEventListener("click", function () {
    const imgURL = sizeGuideZoomWrapper.querySelector("img").src;
    //sizeGuideZoomWrapper.style.backgroundImage = `url("${imgURL}")`;
    sizeGuidePopup.classList.add("active");
  });

  sizeGuidePopup.addEventListener("click", function (e) {
    if (
      e.target.id == "size-guide-popup-wrapper" &&
      e.target.classList.contains("active")
    ) {
      sizeGuidePopup.classList.remove("active");
    }
  });

  sizeGuidePopupClose.addEventListener("click", function (e) {
    sizeGuidePopup.classList.remove("active");
  });

  // sizeGuideZoomWrapper.addEventListener("mousemove", function (e) {
  //   var zoomer = e.currentTarget;
  //   e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
  //   e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
  //   x = (offsetX / zoomer.offsetWidth) * 100;
  //   y = (offsetY / zoomer.offsetHeight) * 100;
  //   zoomer.style.backgroundPosition = x + "% " + y + "%";
  // });
}
